/**
 * DetailPanel - Right panel that switches between 3 states:
 * 1. NetworkSummary (nothing selected)
 * 2. PersonScorecard (node selected)
 * 3. RelationshipPanel (edge selected)
 */

import React from 'react';
import { Box } from '@mui/material';
import NetworkSummary from './NetworkSummary';
import PersonScorecard from './PersonScorecard';
import RelationshipPanel from './RelationshipPanel';

function DetailPanel({
  selectedNode,
  selectedEdge,
  entityId,
  nodes,
  egoId,
  networkStats,
  onClose,
}) {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        bgcolor: 'background.paper',
      }}
    >
      {selectedNode ? (
        <PersonScorecard
          node={selectedNode}
          entityId={entityId}
          onClose={onClose}
        />
      ) : selectedEdge ? (
        <RelationshipPanel
          edge={selectedEdge}
          entityId={entityId}
          nodes={nodes}
          onClose={onClose}
        />
      ) : (
        <NetworkSummary
          entityId={entityId}
          nodes={nodes}
          egoId={egoId}
          networkStats={networkStats}
        />
      )}
    </Box>
  );
}

export default DetailPanel;
